import {
  Button,
  Typography,
  Box,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useState } from "react";
import { post } from "../../../../utils/api";
import SelectField from "../../../../Components/Masters/SelectField";
import formatTitleWithOptional from "../../OptionalFeild";
import InputField from "../../../../Components/Masters/InputField";
import AutoComplete from "../../../../Components/Common/AutoComplete";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";

const BulkUploadAdd = ({
  matchData,
  onClose,
  onConfirm,
  onAddItem,
  setMatchData,
  validateForm,
  index,
  formData,
  errors,
  setErrors,
  setFormData,
  setExpandedRows,
  bulkuploadInputData,
  url,
  submitUrl,
  fuelType,
  equipment,
  isTabbedData,
  activeTab,
  fetchEquipmentList,
  itemAdded,
  title,
  setsnackOpen,
}) => {
  const [equipmentDetails, setEquipmentDetails] = useState([]);
  const [machineDetails, setMachineDetails] = useState([]);

  const equipmentDetailFields = [
    {
      fieldName: "uniqueID",
      title: "Unique ID",
      placeholder: "Enter Unique ID",
      type: "text",
    },
    {
      fieldName: "brand",
      title: "Brand",
      placeholder: "Enter Brand",
      type: "text",
    },
    {
      fieldName: "model",
      title: "Model",
      placeholder: "Enter Model",
      type: "text",
    },
    {
      fieldName: "ratedFuelConsumption",
      title: "Rated Fuel Consumption",
      placeholder: "Enter Value",
      type: "number",
    },
    {
      fieldName: "unitOfFuelConsumption",
      title: "Unit",
      placeholder: "Select Unit",
      type: "text",
      options: ["L/h", "kg/h", "m3/h"],
    },
  ];

  // const handleChange = (type, e,index) => {
  //     const { name, value } = e.target;
  //     if (type==="number" && !/^\d*$/.test(value)) return; // Allow only numeric values
  //     console.log(name,value,"name,value")
  //     setFormData((prev) => ({
  //       ...prev,
  //       [index]:{
  //         ...prev[index],
  //         fuelType:fuelType,
  //         name:equipment,
  //         [name]: value,
  //       },
  //     }));}

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error for the field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: {
        ...prevErrors[index],
        [name]: undefined, // Remove error for the specific field
      },
    }));

    if (isTabbedData) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          data: {
            ...prev[activeTab]?.data,
            [index]: {
              ...prev[activeTab]?.data?.[index],
              fuelType: prev[activeTab]?.data?.[index]?.fuelType || fuelType,
              name: equipment,
              [name]: value,
            },
          }
        }
      }));
    } else {
      setFormData((prev) => {
        const existingData = prev[index] || {};
        return {
          ...prev,
          [index]: {
            ...existingData,
            fuelType: existingData.fuelType || fuelType,
            name: equipment,
            [name]: value,
          },
        };
      });
    }

    if (name === "noOfEquipment") {
      handleNoOfEquipmentChange(value);
    }

    if (name === "numberOfMachines") {
      handleNumberOfMachinesChange(value);
    }
  };

  const handleNoOfEquipmentChange = (value) => {
    const num = parseInt(value) || 0;
    if (num < 0) return;

    // Initialize equipment details array
    const details = Array(num)
      .fill()
      .map(() => ({
        uniqueID: "",
        brand: "",
        model: "",
        ratedFuelConsumption: "",
        unitOfFuelConsumption: "",
      }));

    setEquipmentDetails(details);

    // Also sync to formData if needed immediately
    if (isTabbedData) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          data: {
            ...prev[activeTab]?.data,
            [index]: {
              ...prev[activeTab]?.data?.[index],
              noOfEquipment: value,
              fuelType: prev[activeTab]?.data?.[index]?.fuelType || fuelType,
              equipments: details,
            },
          }
        }
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          noOfEquipment: value,
          fuelType: prev[index]?.fuelType || fuelType,
          equipments: details,
        },
      }));
    }
  };

  const getDefaultUnitByFuelType = (fuelType) => {
    if (
      fuelType === "Diesel (100% mineral diesel)" ||
      fuelType === "Petrol (100% mineral petrol)"
    ) {
      return "Liters";
    } else if (fuelType === "Electricity") {
      return "KWH";
    }
    return ""; // Default fallback
  };

  const handleNumberOfMachinesChange = (value) => {
    const num = parseInt(value) || 0;
    if (num < 0) return;

    const defaultUnit = getDefaultUnitByFuelType(formData?.[activeTab]?.data?.[index]?.fuelType || fuelType);

    // Initialize machine details array
    const details = Array(num)
      .fill()
      .map(() => ({
        uniqueID: "",
        brand: "",
        model: "",
        ratedFuelConsumption: "",
        unitOfFuelConsumption: defaultUnit,
      }));
    setMachineDetails(details);

    // Also sync to formData if needed immediately
    if (isTabbedData) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          data: {
            ...prev[activeTab]?.data,
            [index]: {
              ...prev[activeTab]?.data?.[index],
              numberOfMachines: value,
              fuelType: prev[activeTab]?.data?.[index]?.fuelType || fuelType,
              machines: details,
            },
          }
        }
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          numberOfMachines: value,
          fuelType: prev[index]?.fuelType || fuelType,
          machines: details,
        },
      }));
    }
  };

  const handleEquipmentDetailChange = (e, eqIdx, field) => {
    const value = e.target.value;
    
    // Clear the specific error for the equipment detail field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: {
        ...prevErrors[index],
        [`equipment_${eqIdx}_${field}`]: undefined, // Remove error for the specific equipment detail field
      },
    }));

    const updatedDetails = [...equipmentDetails];
    updatedDetails[eqIdx] = {
      ...updatedDetails[eqIdx],
      unitOfFuelConsumption:
        fuelType === "Natural Gas" || fuelType === "Coal"
          ? "Kg per hour"
          : ["Petroleum/Gasoline", "Diesel", "Fuel Oil","LPG","Propane"].includes(fuelType)
          ? "Ltr per hour"
          : "",
      [field]: value,
    };
    setEquipmentDetails(updatedDetails);

    // Update form data with equipment details
    if (isTabbedData) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          data: {
            ...prev[activeTab]?.data,
            [index]: {
              ...prev[activeTab]?.data?.[index],
              equipments: updatedDetails,
            },
          }
        }
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          equipments: updatedDetails,
        },
      }));
    }
  };

  const handleMachineDetailChange = (e, mIdx, field) => {
    const value = e.target.value;
    
    // Clear the specific error for the machine detail field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: {
        ...prevErrors[index],
        [`machine_${mIdx}_${field}`]: undefined, // Remove error for the specific machine detail field
      },
    }));

    const updatedDetails = [...machineDetails];
    updatedDetails[mIdx] = {
      ...updatedDetails[mIdx],
      [field]: value,
    };
    setMachineDetails(updatedDetails);

    // Update form data with machine details
    if (isTabbedData) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          data: {
            ...prev[activeTab]?.data,
            [index]: {
              ...prev[activeTab]?.data?.[index],
              machines: updatedDetails,
            },
          }
        }
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          machines: updatedDetails,
        },
      }));
    }
  };

  const handleAddItem = async (index) => {
    const currentFormData = isTabbedData ? formData[activeTab]?.data?.[index] : formData[index];
    console.log(currentFormData, validateForm(index), "currentFormData");
    if (!validateForm(index)) {
      return;
    }

    const itemData = {
      ...currentFormData,
    };

    // If machines exists and equipments does not, use machines as equipments
    if (itemData.machines && !itemData.equipments) {
      itemData.equipments = itemData.machines;
      delete itemData.machines;
    }

    try { 
      // Make API call here
      const response = await post(submitUrl, itemData);
      console.log(response, "response");
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      

      fetchEquipmentList();

      // Pass both machinery name and unique IDs to the callback
      const uniqueIds = itemData?.equipments?.map((el) => el.uniqueID) || [];
      itemAdded(itemData.name, uniqueIds);
      // Update the status to matched on success
      if (setMatchData) {
        if (isTabbedData) {
          setMatchData((prev) =>
            prev.map((tab, tabIndex) =>
              tabIndex === activeTab
                ? {
                    ...tab,
                    data: tab.data.map((item, i) =>
                      i === index ? { ...item, matched: true,validUniqueIds:itemData?.equipments?.map((el) => el.uniqueID) } : item
                    )
                  }
                : tab
            )
          );
        } else {
          setMatchData((prev) =>
            prev.map((item, i) =>
              i === index ? { ...item, matched: true } : item
            )
          );
        }
      }

      // Call the parent handler if provided
      if (onAddItem) {
        onAddItem(itemData, index);
      }

      // Close the expanded row
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form data and errors for this index
      if (isTabbedData) {
        setFormData((prev) => ({
          ...prev,
          [activeTab]: {
            ...prev[activeTab],
            data: {
              ...prev[activeTab]?.data,
              [index]: undefined
            }
          }
        }));
      } else {
        setFormData((prev) => {
          const newData = { ...prev };
          delete newData[index];
          return newData;
        });
      }

      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
    } catch (error) {
      console.error("Error adding equipment:", error);
      // Handle error - you can show an error message here
    }
  };
  return (
    <Box
      sx={{
        margin: 1,
        // backgroundColor: "#f8f9fa",
      }}
    >
      <Typography variant="h6" gutterBottom component="div">
        {title==="Machinery Name" ? "Add Machinery: " + equipment : "Add Equipment: " + equipment}
      </Typography>
      <Grid container spacing={2}>
        {bulkuploadInputData?.map((items, i) => (
          <Grid item xs={12} sm={6} key={i}>
            {items.type === "text" || items.type === "number" ? (
              <InputField
                title={items.title}
                handleChange={handleChange}
                placeholder={items.placeholder}
                value={
                  items.title === "Equipment Name" || items.title === "Machinery Name"
                    ? equipment
                    : items.title === "Fuel Type"
                    ? fuelType
                    : isTabbedData 
                      ? formData[activeTab]?.data?.[index]?.[items.fieldName] || ""
                      : formData[index]?.[items.fieldName] || ""
                }
                fieldName={items.fieldName}
                disabled={items.fieldName==="Equipment Name" || items.fieldName==="Machinery Name" ? true : false}
                type={items.type}
                errors={errors[index]?.[items.fieldName]}
              />
            ) : items.fieldName === "categoryType" ? (
              <AutoComplete
                title={formatTitleWithOptional(items.title)}
                name={items.fieldName}
                handleChange={handleChange}
                value={isTabbedData ? formData[activeTab]?.data?.[index]?.[items.fieldName] || "" : formData[index]?.[items.fieldName] || ""}
                options={items.options}
                errors={errors[index]?.[items.fieldName]}
              />
            ) : items.fieldName === "consumptionPeriod" ? (
              <Box sx={{ mt: 1 }}>
                <MonthYearPicker
                  {...{
                    name: items.fieldName,
                    setFormData,
                    // setFormData2,
                    formData,
                    errors,
                    setErrors,
                    title: items.title,
                    // defaultMonth: formData?.consumptionPeriod?.month || "",
                    // defaultYear: formData?.consumptionPeriod?.year || "",
                  }}
                />
              </Box>
            ) : (
              <SelectField
                title={items.title}
                name={items.fieldName}
                value={isTabbedData ? formData[activeTab]?.data?.[index]?.[items.fieldName] || "" : formData[index]?.[items.fieldName] || ""}
                handleChange={handleChange}
                options={items.options}
                errors={errors[index]?.[items.fieldName]}
                url={items.selectUrl}
                field={items.field}
              />
            )}
          </Grid>
        ))}

        {(isTabbedData ? formData[activeTab]?.data?.[index]?.numberOfMachines : formData[index]?.numberOfMachines) > 0 && (
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
              Machine Details
            </Typography>
            {machineDetails.map((machine, mIdx) => (
              <Box
                key={mIdx}
                sx={{ mb: 2, p: 2, border: "1px solid #ddd", borderRadius: 1 }}
              >
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Machine {mIdx + 1}
                </Typography>
                <Grid container spacing={2}>
                  {equipmentDetailFields.map((field, fieldIdx) => (
                    <Grid item xs={12} sm={6} key={fieldIdx}>
                      {field.type === "select" ? (
                        <FormControl fullWidth size="small">
                          <Select 
                            value={machine[field.fieldName] || ""}
                            onChange={(e) =>
                              handleMachineDetailChange(
                                e,
                                mIdx,
                                field.fieldName
                              )
                            }
                            label={field.title}
                          >
                            {field.options.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          placeholder={field.placeholder}
                          value={
                            field.fieldName === "unitOfFuelConsumption"
                              ? getDefaultUnitByFuelType(fuelType) ||
                                machine[field.fieldName] ||
                                ""
                              : machine[field.fieldName] || ""
                          }
                          onChange={(e) =>
                            handleMachineDetailChange(e, mIdx, field.fieldName)
                          }
                          type={field.type}
                          sx={{ 
                            mb: 1,
                            "& .MuiFormHelperText-root": {
                              marginLeft: 0
                            }
                          }}
                          disabled={
                            field.fieldName === "unitOfFuelConsumption" 
                          }
                          error={!!errors[index]?.[`machine_${mIdx}_${field.fieldName}`]}
                          helperText={errors[index]?.[`machine_${mIdx}_${field.fieldName}`]}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Grid>
        )}

        {/* Equipment Details Section */}
        {(isTabbedData ? formData[activeTab]?.data?.[index]?.noOfEquipment : formData[index]?.noOfEquipment) > 0 && (
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
              Equipment Details
            </Typography>

            {equipmentDetails?.map((equipment, eqIdx) => (
              <Box
                key={eqIdx}
                sx={{ mb: 2, p: 2, border: "1px solid #ddd", borderRadius: 1 }}
              >
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Equipment {eqIdx + 1}
                </Typography>

                <Grid container spacing={2}>
                  {equipmentDetailFields.map((field, fieldIdx) => (
                    <Grid item xs={12} sm={6} key={fieldIdx}>
                      {field.type === "select" ? (
                        <FormControl fullWidth size="small">
                          {/* <InputLabel>{field.title}</InputLabel> */}
                          <Select
                            value={equipment[field.fieldName] || ""}
                            onChange={(e) =>
                              handleEquipmentDetailChange(
                                e,
                                eqIdx,
                                field.fieldName
                              )
                            }
                          >
                            {field.options.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          // label={field.title}
                          placeholder={field.placeholder}
                          value={
                            field.fieldName === "unitOfFuelConsumption"
                              ? fuelType === "Natural Gas" ||
                                fuelType === "Coal"
                                ? "Kg per hour"
                                : [
                                    "Petroleum/Gasoline",
                                    "Diesel",
                                    "Fuel Oil",
                                    "LPG",
                                    "Propane"
                                  ].includes(fuelType)
                                ? "Ltr per hour"
                                : ""
                              : equipment[field.fieldName] || ""
                          }
                          onChange={(e) =>
                            handleEquipmentDetailChange(
                              e,
                              eqIdx,
                              field.fieldName
                            )
                          }
                          type={field.type}
                          sx={{ 
                            mb: 1,
                            "& .MuiFormHelperText-root": {
                              marginLeft: 0
                            }
                          }}
                          disabled={
                            field.fieldName === "unitOfFuelConsumption"
                              ? true
                              : false
                          }
                          error={!!errors[index]?.[`equipment_${eqIdx}_${field.fieldName}`]}
                          helperText={errors[index]?.[`equipment_${eqIdx}_${field.fieldName}`]}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Grid>
        )}

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAddItem(index)}
              sx={{ mt: 1 }}
            >
              {title==="Machinery Name" ? "Add Machinery" : "Add Equipment"}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default BulkUploadAdd;
